import React, { createContext, useContext } from 'react';
import { useSnackbar } from '../hooks/useSnackbar';
import { useSubscriptions } from '../hooks/useSubscriptions';
import { useReceipts } from '../hooks/useReceipts';
import { useAnalytics } from '../hooks/useAnalytics';
import { useQuizLeads } from '../hooks/useQuizLeads';
import { useQuizzes } from '../hooks/useQuizzes';
import { useMagazines } from '../hooks/useMagazines';
import { useWhatsApp } from '../hooks/useWhatsApp';

const SuperDuperContext = createContext(null);

/**
 * Owns every piece of admin dashboard state so that the individual tabs stay
 * presentational. Each domain lives in its own hook; this provider only
 * composes them and exposes a flat value object.
 */
export const SuperDuperProvider = ({ children }) => {
  const { snackbar, showSnackbar, handleCloseSnackbar } = useSnackbar();

  const subscriptions = useSubscriptions(showSnackbar);
  const receipts = useReceipts(showSnackbar);
  const analytics = useAnalytics();
  const quizLeads = useQuizLeads();
  const quizzes = useQuizzes(showSnackbar);
  const magazines = useMagazines(showSnackbar);
  const whatsapp = useWhatsApp(showSnackbar);

  const value = {
    snackbar,
    showSnackbar,
    handleCloseSnackbar,
    ...subscriptions,
    ...receipts,
    ...analytics,
    ...quizLeads,
    ...quizzes,
    ...magazines,
    ...whatsapp
  };

  return (
    <SuperDuperContext.Provider value={value}>
      {children}
    </SuperDuperContext.Provider>
  );
};

export const useSuperDuper = () => {
  const context = useContext(SuperDuperContext);
  if (!context) {
    throw new Error('useSuperDuper must be used within a SuperDuperProvider');
  }
  return context;
};
